var Handlebars = require("handlebars/runtime");
module.exports = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"icon-circle__number\">"
    + container.escapeExpression(((helper = (helper = helpers.num || (depth0 != null ? depth0.num : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data}) : helper)))
    + "</div>";
},"useData":true});



//////////////////
// WEBPACK FOOTER
// ./shared/view/CircleNumberView/CircleNumberView.hbs
// module id = 657
// module chunks = 46 47